import { render, staticRenderFns } from "./ImgLyScenes.vue?vue&type=template&id=3471a87c"
import script from "./ImgLyScenes.vue?vue&type=script&lang=js"
export * from "./ImgLyScenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports